// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"105ec6e1","278":"8bbf30e7","734":"73e0acee"}[chunkId] + ".chunk.css";
};